// @flow

export default {
  CHECKBOX: 'checkbox',
  PRICE: 'price-range',
  SELECTED: 'selected'
};
